import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CorreosButton } from "../../CorreosButton/CorreosButton";
import { Container, Dialog, Grid, IconButton, Tooltip, Typography } from "@material-ui/core";
import { CommonStyles } from "../../../commons/CommonStyles";
import { DialogStyles } from "../../CommonComponents/Dialogs/DialogStyles";
import { checkIsNullUndefined, getErrorMessage } from "../../../commons/Utils";
import { PutSystemUserResetCredentialsByUser, PutSystemUserResetCredentialsByEnterprise } from "../../../services/ReasonService";
import { CorreosIcon } from "../../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../../commons/EnumsGeneral";

export function DialogChangeSecret(props) {
    const { systemUserData, finishOperation, idEnterprise, /*isOrganization,*/ isTitular } = props;
    const { t } = useTranslation();
    const commonClasses = CommonStyles();
    const dialogClasses = DialogStyles();

    const [open, setOpen] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [clientSecret, setClientSecret] = useState(false);
    const [identifier, setIdentifier] = useState(false);
    const [circularProgress, setCircularProgress] = useState(false);

    useEffect(() => {
        let auxIdentifier = checkIsNullUndefined(systemUserData.systemUserName) ? systemUserData.client_id : systemUserData.systemUserName;
        setIdentifier(auxIdentifier);
    }, [systemUserData]);

    const handleConfirm = () => {
        setCircularProgress(true);
        let auxCall = checkIsNullUndefined(idEnterprise) ? PutSystemUserResetCredentialsByUser : PutSystemUserResetCredentialsByEnterprise;
        auxCall(systemUserData.client_id, idEnterprise).then((response) => {
            if (response && !response.Status) {
                setIsChanged(true);
                setClientSecret(response.client_secret);
            } else {
                finishOperation("error", getErrorMessage(response));
            };
            setCircularProgress(false);
        });
    };

    const handleClose = () => {
        setOpen(false);
        setIsChanged(false);
    };

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(t("systemUserPageClientSecret") + ": " + clientSecret).then(() => {
            finishOperation("success", t("systemUserPageClientSecretCopySuccess"));
        }).catch(err => {
            finishOperation("error", t("systemUserPageClientSecretCopyError"));
        });
    };

    const getText = () => {
        if (isChanged) {
            return (
                <>
                    <Typography style={{ marginBottom: "1em" }}>{t("systemUserPageClientSecretChanged")}</Typography>
                    <Typography><b>{t("systemUserPageClientSecret") + ": "}</b><span>{clientSecret}</span></Typography>
                </>
            );
        } else {
            return t("systemUserPageClientSecretText").replace("{user}", identifier);
        };
    };

    return (
        <>
            <Tooltip title={t("systemUserPageClientSecretRestore")} placement="top">
                <IconButton
                    edge="inherit"
                    className={commonClasses.iconButton}
                    onClick={() => setOpen(true)}
                    disabled={/*isOrganization &&*/ !isTitular}
                >
                    <CorreosIcon iconSelected={iconNames.lock} iconName="Lock Icon" iconState={(/*isOrganization &&*/ !isTitular) ? "disabled" : "enabled"} iconScale={1.5} />
                </IconButton>
            </Tooltip>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
            >
                <Container className={dialogClasses.dialogTitle}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                className={dialogClasses.dialogTitleText}
                            >
                                {t("systemUserPageClientSecretTitle")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
                <Container className={dialogClasses.dialogContainer}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography className={dialogClasses.dialogContentText}>
                                {getText()}
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={12}
                            className={dialogClasses.dialogButtonContainer}
                        >
                            <Grid item xs={6}>
                                <CorreosButton
                                    onClick={handleClose}
                                    className={dialogClasses.dialogButtonLeft}
                                >
                                    {isChanged ? t("close") : t("cancel")}
                                </CorreosButton>
                            </Grid>
                            <Grid item xs={6}>
                                <CorreosButton
                                    variant="contained"
                                    color="primary"
                                    onClick={isChanged ? handleCopyToClipboard : handleConfirm}
                                    className={dialogClasses.dialogButtonRight}
                                    circularProgress={circularProgress}
                                >
                                    {isChanged ? t("copy") : t("accept")}
                                </CorreosButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Dialog>
        </>
    );
}
